module.exports = __webpack_public_path__ + "static/img/KINGSTON_MAPLE.d493621.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/KINGSTON_MAPLE.jpg
// module id = jRSN
// module chunks = 0